import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Observable } from 'rxjs';
import { CRMStatusPedidoBI, CRMTipoBI, TipoDeLogAcesso } from 'src/app/models/enum';
import { Pedido } from 'src/app/models/pedido';
import { CRMBIService } from 'src/app/services/crm/crm-bi.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { CadastrarAtividadeComponent } from '../../atividade/cadastrar-atividade/cadastrar-atividade.component';
import { LogAcessoService } from 'src/app/services/log-acesso.service';
import { Router } from '@angular/router';
import { LogAcesso } from 'src/app/models/log-acesso';
import { CRMBIFaixa, CRMBIProdutoDTO } from 'src/app/models/crm/crmbiproduto';

@Component({
  selector: 'app-bi-integrador-pedido',
  templateUrl: './bi-integrador-pedido.component.html',
  styleUrls: ['./bi-integrador-pedido.component.scss'],
})
export class BiIntegradorPedidoComponent implements OnInit {
  @Input() idIntegrador: number;

  data: {
    ult10Ped: Pedido[];
    paineis: CRMBIProdutoDTO[];
    inversores: CRMBIProdutoDTO[];
    faixas: CRMBIFaixa[];
    valorTot30: number;
    valorTot90: number;
    valorTotGeral: number;
    ticketMedio30: number;
    ticketMedio90: number;
    ticketMedioGeral: number;
    firstPed: Date;
    lastPed: Date;
    totalPot30: number;
    totalPot90: number;
    totalPotGeral: number;
    mediaPot30: number;
    mediaPot90: number;
    mediaPotGeral: number;
    maiorPed: number;
    pedCancelados: number;
    quantitativo30: number;
    quantitativo90: number;
    quantitativoGeral: number;
  } = {
    ult10Ped: [],
    paineis: [],
    inversores: [],
    faixas: [],
    valorTot30: 0,
    valorTot90: 0,
    valorTotGeral: 0,
    ticketMedio30: 0,
    ticketMedio90: 0,
    ticketMedioGeral: 0,
    firstPed: new Date(),
    lastPed: new Date(),
    totalPot30: 0,
    totalPot90: 0,
    totalPotGeral: 0,
    mediaPot30: 0,
    mediaPot90: 0,
    mediaPotGeral: 0,
    maiorPed: 0,
    pedCancelados: 0,
    quantitativo30: 0,
    quantitativo90: 0,
    quantitativoGeral: 0,
  };

  loadingStates = {
    ult10Ped: true,
    paineis: true,
    inversores: true,
    faixas: true,
    valorTot30: true,
    valorTot90: true,
    valorTotGeral: true,
    ticketMedio30: true,
    ticketMedio90: true,
    ticketMediaGeral: true,
    firstPed: true,
    lastPed: true,
    totalPot30: true,
    totalPot90: true,
    totalPorGeral: true,
    mediaPot30: true,
    mediaPot90: true,
    mediaPotGel: true,
    maiorPed: true,
    pedCancelados: true,
    quantitativo30: true,
    quantitativo90: true,
    quantitativoGeral: true,
  };

  integrador: boolean = false;
  status = [
    { id: 1, descricao: 'Todos' },
    { id: 0, descricao: 'Ativo' },
    { id: 5, descricao: 'Cancelado' },
    { id: 3, descricao: 'Expirado' },
  ];
  statusSelecionado = 1;
  periodo = [
    { id: 0, descricao: 'Todos' },
    { id: 1, descricao: 'Últimos 12 Meses' },
    { id: 2, descricao: 'Ano Corrente' },
  ];
  periodoSelecionado = 0;

  view: [number, number] = [500, 300];

  // options
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';
  legendName: string = 'Faixa de Potência (kWp)';

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#848484', '#FF8000', '#FFBF00', '#000000', '#AAAAAA'],
  };

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<CadastrarAtividadeComponent>,
    private globalService: GlobalService,
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    private biService: CRMBIService,
    private logAcessoService: LogAcessoService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();
    this.filtra();
    this.filtraProdutos();
  }

  private loadData(propriedade: string, mensagemErro: string, serviceCall: () => Observable<any>) {
    this.loadingStates[propriedade] = true;
    serviceCall().subscribe(
      (data) => {
        this.data[propriedade] = data;
        this.loadingStates[propriedade] = false;
      },
      () => {
        this.loadingStates[propriedade] = false;
        this.notificacaoService.erro(mensagemErro);
      },
    );
  }

  filtra() {
    this.loadData('ult10Ped', 'Não foi possível buscar os últimos 10 pedidos.', () =>
      this.biService.ultimos10(this.idIntegrador, CRMTipoBI.Pedido, this.statusSelecionado),
    );
    this.loadData('valorTot30', 'Não foi possível buscar o valor total dos pedidos dos últimos 30 dias.', () =>
      this.biService.valorTotal(30, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('valorTot90', 'Não foi possível buscar o valor total dos pedidos dos últimos 90 dias.', () =>
      this.biService.valorTotal(90, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('valorTotGeral', 'Não foi possível buscar o valor total dos pedidos.', () =>
      this.biService.valorTotal(null, this.idIntegrador, CRMTipoBI.Pedido, true, this.statusSelecionado),
    );
    this.loadData('quantitativo30', 'Não foi possível buscar a quantidade dos pedidos dos últimos 30 dias.', () =>
      this.biService.qtdTotalOrcPed(30, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('quantitativo90', 'Não foi possível buscar a quantidade dos pedidos dos últimos 90 dias.', () =>
      this.biService.qtdTotalOrcPed(90, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('quantitativoGeral', 'Não foi possível buscar a quantidade total dos pedidos.', () =>
      this.biService.qtdTotalOrcPed(null, this.idIntegrador, CRMTipoBI.Pedido, true, this.statusSelecionado),
    );
    this.loadData('ticketMedio30', 'Não foi possível buscar a média dos pedidos dos últimos 30 dias.', () =>
      this.biService.ticketMedio(30, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('ticketMedio90', 'Não foi possível buscar a média dos pedidos dos últimos 90 dias.', () =>
      this.biService.ticketMedio(90, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('ticketMedioGeral', 'Não foi possível buscar a média dos pedidos.', () =>
      this.biService.ticketMedio(null, this.idIntegrador, CRMTipoBI.Pedido, true, this.statusSelecionado),
    );
    this.loadData('firstPed', 'Não foi possível buscar o primeiro pedido.', () =>
      this.biService.firstLastOrcPed(this.idIntegrador, CRMTipoBI.Pedido, true, this.statusSelecionado),
    );
    this.loadData('lastPed', 'Não foi possível buscar o último pedido.', () =>
      this.biService.firstLastOrcPed(this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('totalPot30', 'Não foi possível buscar a potência dos pedidos dos últimos 30 dias.', () =>
      this.biService.totalPotenciaOrcPed(30, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('totalPot90', 'Não foi possível buscar a potência dos pedidos dos últimos 90 dias.', () =>
      this.biService.totalPotenciaOrcPed(90, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('totalPotGeral', 'Não foi possível buscar a potência dos pedidos.', () =>
      this.biService.totalPotenciaOrcPed(null, this.idIntegrador, CRMTipoBI.Pedido, true, this.statusSelecionado),
    );
    this.loadData('mediaPot30', 'Não foi possível buscar a média da potência dos pedidos dos últimos 30 dias.', () =>
      this.biService.mediaPotenciaOrcPed(30, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('mediaPot90', 'Não foi possível buscar a média da potência dos pedidos dos últimos 90 dias.', () =>
      this.biService.mediaPotenciaOrcPed(90, this.idIntegrador, CRMTipoBI.Pedido, false, this.statusSelecionado),
    );
    this.loadData('mediaPotGeral', 'Não foi possível buscar a média da potência dos pedidos.', () =>
      this.biService.mediaPotenciaOrcPed(null, this.idIntegrador, CRMTipoBI.Pedido, true, this.statusSelecionado),
    );
    this.loadData('maiorPed', 'Não foi possível buscar o pedido de maior valor.', () =>
      this.biService.maiorOrcPed(this.idIntegrador, CRMTipoBI.Pedido, this.statusSelecionado),
    );
  }

  filtraProdutos() {
    this.loadData('paineis', 'Falha ao carregar dados do painel.', () =>
      this.biService.topPainelInversor(this.idIntegrador, CRMTipoBI.Pedido, this.periodoSelecionado, 2),
    );
    this.loadData('inversores', 'Falha ao carregar dados do inversores.', () =>
      this.biService.topPainelInversor(this.idIntegrador, CRMTipoBI.Pedido, this.periodoSelecionado, 3),
    );
    this.loadData('faixas', 'Falha ao carregar das faixas do painel.', () =>
      this.biService.faixasProdutos(this.idIntegrador, CRMTipoBI.Pedido, this.periodoSelecionado),
    );
  }

  verificaStatus(pedido: Pedido): string {
    if (pedido.status === 0) {
      return 'Ativo';
    }

    if (pedido.status === 5) {
      return pedido.idMotivoPerda != null && pedido.idMotivoPerda != 1 ? 'Cancelado' : 'Expirado';
    }

    return '';
  }

  dataHumanizada(data: string): string {
    const now = new Date();
    const dateNasc = new Date(data);
    const diff = now.getTime() - dateNasc.getTime();

    const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
    const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    const textYears = years > 1 ? 'anos' : 'ano';
    const textDays = days > 1 ? 'dias' : 'dia';
    const textHours = hours > 1 ? 'horas' : 'hora';

    let result = '';

    if (years > 0) {
      result += `${years} ${textYears}`;
    }

    if (days > 0) {
      if (result.length > 0) {
        result += ', ';
      }
      result += `${days} ${textDays}`;
    }

    if (hours > 0) {
      if (result.length > 0) {
        result += ' e ';
      }
      result += `${hours} ${textHours}`;
    }

    if (result.length === 0) {
      return 'Recentemente';
    }

    return result + ' atrás';
  }

  gerarLogAcesso(idCupom: string, tipo: TipoDeLogAcesso) {
    const logAcesso: LogAcesso = {
      tipo,
      idCupom,
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => {});
  }

  editarPedido(idCupom: string) {
    this.gerarLogAcesso(idCupom, TipoDeLogAcesso.EditarPedido);

    const url = `/pedidos/editar/${idCupom}`;
    window.open(url, '_blank'); // Abre a nova janela
  }
}
